import {InfiniteData, useQueryClient} from '@tanstack/react-query';
import {useRouter} from 'next/router';
import {useMemo} from 'react';
import {selectListAndRestData} from '../../../common/selectListAndRestData';
import {SearchKeywordQuery} from '../../../graphql/generated/types';
import {useInfiniteSearchKeywordQuery} from '../../../wrapper/searchWrapper';
import {createSearchKeywordInput} from '../util/createSearchKeywordInput';
import {validateSearchKeywordSearchParam} from '../util/typeguard';

/**
 * 현재 query로 queryKey를 만들어서 캐싱된 검색결과 데이터를 가져옵니다.
 */
export function useGetSearchKeywordQueryData() {
  const queryClient = useQueryClient();
  const {query} = useRouter();
  const searchKeywordInput = useMemo(() => {
    if (!validateSearchKeywordSearchParam(query)) {
      return;
    }
    return createSearchKeywordInput(query);
  }, [query]);
  const queryKey = searchKeywordInput
    ? useInfiniteSearchKeywordQuery.getKey({input: searchKeywordInput})
    : undefined;
  const searchInfiniteData = queryKey
    ? queryClient.getQueryData<InfiniteData<SearchKeywordQuery>>(queryKey)
    : undefined;
  const searchData = selectListAndRestData<SearchKeywordQuery, 'searchKeyword'>(
    'searchKeyword',
    searchInfiniteData
  );

  return {
    searchInfiniteData,
    searchData,
  };
}
